@if (hasLegalization) {
  <app-expansive-leagalization-documents-list [workerId]="this.profile.WorkerId"> </app-expansive-leagalization-documents-list>
  @if (!isDocumentsOnWorkerProfileVisible()) {
    <app-education-history-documents-section [workerId]="this.profile.WorkerId" [readonly]="true"> </app-education-history-documents-section>
    <app-additional-documents-section [workerId]="this.profile.WorkerId" [readonly]="true"> </app-additional-documents-section>
  }
}

@if (isDocumentsOnWorkerProfileVisible() && files$ | async; as files) {
  <div>
    <mat-accordion>
      <mat-expansion-panel [expanded]="hasAnyStatementsDocuments">
        <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight" [expandedHeight]="documentsExpansionHeaderHeight">
          <mat-panel-title>
            <h2>{{ 'DocumentsBeforeEmployment' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- Statements -->
        <div class="table-wrapper">
          <table class="five-cols">
            <thead>
              <tr>
                <th class="column-question">{{ 'Question' | translate }}</th>
                <th class="column-filename">{{ 'Name' | translate }}</th>
                <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
                <th class="column-isattached">{{ 'Status' | translate }}</th>
                <th class="column-actions">{{ 'Actions' | translate }}</th>
              </tr>
            </thead>
            <tbody class="documents-table">
              @for (statement of files?.DocumentStatements; track statement) {
                <tr class="table-row">
                  <td class="column-question">{{ statement.QuestionText }}</td>
                  @if (statement.Files.length === 0) {
                    <td class="column-date"></td>
                    <td class="column-filename"></td>
                    <td class="column-actions">
                      <button
                        id="documents-section-add-document-statement-button"
                        mat-icon-button
                        color="primary"
                        (click)="addFile(statement.QuestionId, statement.QuestionText)"
                      >
                        <mat-icon>add_box</mat-icon>
                      </button>
                    </td>
                  }
                  <td class="column-filename">
                    @for (file of statement.Files; track file) {
                      <div>
                        @if (file.Id != null) {
                          <a href="javascript:void(0)" (click)="showFile(file.Id, file.Name)">{{ file.Name }}</a>
                        }
                        @if (file.VerificationStatusId === workerFileVerificationStatusEnum.Pending) {
                          <mat-icon class="verification-badge verification-badge--pending"
                            [matTooltip]="'WorkerFilePendingVerificationTooltip' | translate">schedule</mat-icon>
                        }
                        @if (file.VerificationStatusId === workerFileVerificationStatusEnum.Rejected) {
                          <mat-icon class="verification-badge verification-badge--rejected"
                            [matTooltip]="file.RejectionReason ?? ('WorkerFileRejectedTooltip' | translate)">cancel</mat-icon>
                        }
                      </div>
                    }
                  </td>
                  <td class="column-date">
                    @for (file of statement.Files; track file) {
                      <div>
                        {{ file.AddedDate | date: 'yyyy-MM-dd' }}
                      </div>
                    }
                  </td>
                  <td class="column-isattached">
                    @if (!statement?.IsDocumentIncluded) {
                      <span><mat-icon>error</mat-icon></span>
                    }
                    @if (statement?.IsDocumentIncluded) {
                      <span><mat-icon>check</mat-icon></span>
                    }
                  </td>
                  <td class="column-actions">
                    @for (file of statement.Files; track file) {
                      <div>
                        @if (file.Id != null) {
                          <button
                            id="documents-section-download-document-statement-button"
                            mat-icon-button
                            color="primary"
                            (click)="downloadFile(file.Id, file.Name)"
                          >
                            <mat-icon>download</mat-icon>
                          </button>
                        }
                        @if (file.Id == null || statement.AttachmentCountLimit > statement.Files.length) {
                          <button
                            id="documents-section-add-document-statement-from-details-button"
                            mat-icon-button
                            color="primary"
                            (click)="addFile(statement.QuestionId, statement.QuestionText)"
                          >
                            <mat-icon>add_box</mat-icon>
                          </button>
                        }
                        <button
                          id="documents-section-delete-document-statement-button"
                          mat-icon-button
                          color="primary"
                          [visibleWithPermissions]="['DeleteWorkerFiles']"
                          (click)="deleteFile(file.Id)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion>
      <!--  WorkerFamilyMembers -->
      <mat-expansion-panel *hasPermissionToModule="moduleNames.FamilyMembers; workerId: profile.WorkerId">
        <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight" [expandedHeight]="documentsExpansionHeaderHeight">
          <mat-panel-title>
            <h2>{{ 'WorkerFamilyMembersDocuments' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="document-buttons">
          <span [matTooltipDisabled]="canAddFamilyMemberDocument" [matTooltip]="'AddFamilyMemberFileInformation' | translate">
            <button
              id="documents-section-add-family-document-button"
              mat-raised-button
              color="primary"
              [disabled]="!canAddFamilyMemberDocument"
              (click)="openWorkerFamilyMembersModal()"
            >
              {{ 'WL-AddDocument' | translate }}
            </button>
          </span>
        </div>
        <div class="table-wrapper">
          <table class="five-cols">
            <thead>
              <tr>
                <th class="column-fullname">{{ 'FullName' | translate }}</th>
                <th class="column-filename">{{ 'Name' | translate }}</th>
                <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
                <th class="column-isattached">{{ 'Status' | translate }}</th>
                <th class="column-actions">{{ 'Actions' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (file of files?.WorkerFamilyMembersFiles | filterPurely: familyMemberFilter; track file) {
                <tr>
                  <td class="column-fullname">{{ file?.FullName }}</td>
                  <td class="column-filename">
                    @for (f of file.Files; track f) {
                      <div>
                        <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name, file.WorkerFamilyMemberId)">{{ f.Name }}</a>
                        @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Pending) {
                          <mat-icon
                            class="verification-badge verification-badge--pending"
                            [matTooltip]="'WorkerFilePendingVerificationTooltip' | translate"
                            >schedule</mat-icon
                          >
                        }
                        @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Rejected) {
                          <mat-icon
                            class="verification-badge verification-badge--rejected"
                            [matTooltip]="f.RejectionReason ?? ('WorkerFileRejectedTooltip' | translate)"
                            >cancel</mat-icon
                          >
                        }
                      </div>
                    }
                  </td>
                  <td class="column-date">
                    @for (f of file.Files; track f) {
                      <div>{{ f?.CreatedOn | date: 'yyyy-MM-dd' }}</div>
                    }
                  </td>
                  <td class="column-isattached">
                    @if (!file.Files) {
                      <span><mat-icon>error</mat-icon></span>
                    }
                    @if (!!file.Files) {
                      <span><mat-icon>check</mat-icon></span>
                    }
                  </td>
                  <td class="column-actions">
                    @for (f of file.Files; track f) {
                      <div>
                        <button
                          id="documents-section-download-family-document-button"
                          mat-icon-button
                          color="primary"
                          (click)="downloadFile(f.Id, f.Name, file.WorkerFamilyMemberId)"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <app-education-history-documents-section [workerId]="profile.WorkerId" [canAddEducationDocument]="canAddEducationDocument"> </app-education-history-documents-section>

    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header [collapsedHeight]="documentsExpansionHeaderHeight" [expandedHeight]="documentsExpansionHeaderHeight">
          <mat-panel-title>
            <h2>{{ 'EmploymentHistoryDocuments' | translate }}</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="document-buttons">
          <button
            id="documents-section-add-employment-menu-document-button"
            mat-raised-button
            color="primary"
            [matMenuTriggerFor]="menu"
            [disabled]="!canAddDocument"
          >
            {{ 'WP-AddDocument' | translate }}
          </button>
          <mat-menu #menu="matMenu" class="documents-menu-wide">
            @if (documentTypeIds?.includes(documentTypes.PIT2)) {
              <div [matTooltip]="'PIT2Tooltip' | translate" [matTooltipDisabled]="canGeneratePIT2">
                <button id="documents-section-pit-document-button" mat-menu-item [disabled]="!canGeneratePIT2" (click)="openPIT2Dialog()">
                  {{ 'WL-PIT2' | translate }}
                </button>
              </div>
            }
            @if (documentTypeIds?.includes(documentTypes.PpkCancellation)) {
              <div [matTooltip]="'WL-PpkCancellationTooltip' | translate" [matTooltipDisabled]="canGeneratePpkResignation">
                <button
                  id="documents-section-ppk-cancellation-document-button"
                  mat-menu-item
                  [disabled]="!canGeneratePpkResignation"
                  (click)="openPpkCancellationDialog()"
                >
                  {{ 'WL-PpkCancellation' | translate }}
                </button>
              </div>
            }
            @if (documentTypeIds?.includes(documentTypes.HolidayChildCareStatement)) {
              <div [matTooltip]="'WL-ChildCareTooltip' | translate" [matTooltipDisabled]="canGenerateHolidayChildCareStatementDialog">
                <button
                  id="documents-section-holiday-child-care-document-button"
                  mat-menu-item
                  [disabled]="!canGenerateHolidayChildCareStatementDialog"
                  (click)="openHolidayChildCareDialog()"
                >
                  {{ 'WL-HolidayChildCare' | translate }}
                </button>
              </div>
            }
          </mat-menu>
          <span [matTooltipDisabled]="canAddDocument" [matTooltip]="'AddEmploymentDocumentInformation' | translate">
            <button
              id="documents-section-add-employment-document-button"
              mat-raised-button
              color="primary"
              [disabled]="!canAddDocument"
              (click)="openEmploymentHistoryDialog()"
            >
              {{ 'WL-AddDocument' | translate }}
            </button>
          </span>
        </div>
        <div class="table-wrapper">
          <table class="six-cols">
            <thead>
              <tr>
                <th class="column-fullname">{{ 'WL-WorkerFileType' | translate }}</th>
                <th class="column-filename">{{ 'Name' | translate }}</th>
                <th class="column-description">{{ 'Description' | translate }}</th>
                <th class="column-date">{{ 'CreatedOnDate' | translate }}</th>
                <th class="column-isattached">{{ 'Status' | translate }}</th>
                <th class="column-actions">{{ 'Actions' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (file of files?.DocumentFiles | filterPurely: sectionFilter(workerTypeSectionEnum.EmploymentHistoryFilesSection); track file) {
                @for (sFile of file.SectionFiles; track sFile) {
                  <tr>
                    <td class="column-fullname">
                      {{ sFile.FileTypeName }}
                    </td>
                    <td class="column-filename">
                      @for (f of sFile.WorkerFiles; track f) {
                        <div>
                          <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name)">{{ f.Name }}</a>
                          @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Pending) {
                            <mat-icon
                              class="verification-badge verification-badge--pending"
                              [matTooltip]="'WorkerFilePendingVerificationTooltip' | translate"
                              >schedule</mat-icon
                            >
                          }
                          @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Rejected) {
                            <mat-icon
                              class="verification-badge verification-badge--rejected"
                              [matTooltip]="f.RejectionReason ?? ('WorkerFileRejectedTooltip' | translate)"
                              >cancel</mat-icon
                            >
                          }
                        </div>
                      }
                    </td>
                    <td class="column-description">
                      @for (f of sFile.WorkerFiles; track f) {
                        <div>{{ f?.Description }}</div>
                      }
                    </td>
                    <td class="column-date">
                      @for (f of sFile.WorkerFiles; track f) {
                        <div>{{ f?.CreatedOn | date: 'yyyy-MM-dd' }}</div>
                      }
                    </td>
                    <td class="column-isattached">
                      @if (!sFile.WorkerFiles) {
                        <span><mat-icon>error</mat-icon></span>
                      }
                      @if (!!sFile.WorkerFiles) {
                        <span><mat-icon>check</mat-icon></span>
                      }
                    </td>
                    <td class="column-actions">
                      @for (f of sFile.WorkerFiles; track f) {
                        <div>
                          <button
                            id="documents-section-download-employment-section-document-button"
                            mat-icon-button
                            color="primary"
                            (click)="downloadFile(f.Id, f.Name)"
                          >
                            <mat-icon>download</mat-icon>
                          </button>
                        </div>
                      }
                    </td>
                  </tr>
                }
              }
              @for (file of files?.EmploymentHistoryFiles; track file) {
                <tr>
                  <td class="column-fullname">{{ 'EmploymentHistoryFileType' | translate }}</td>
                  <td class="column-filename">
                    @for (f of file.Files; track f) {
                      <div>
                        <a href="javascript:void(0)" (click)="showFile(f.Id, f.Name, file.EmploymentHistoryRecordId)">{{ f.Name }}</a>
                        @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Pending) {
                          <mat-icon
                            class="verification-badge verification-badge--pending"
                            [matTooltip]="'WorkerFilePendingVerificationTooltip' | translate"
                            >schedule</mat-icon
                          >
                        }
                        @if (f.VerificationStatusId === workerFileVerificationStatusEnum.Rejected) {
                          <mat-icon
                            class="verification-badge verification-badge--rejected"
                            [matTooltip]="f.RejectionReason ?? ('WorkerFileRejectedTooltip' | translate)"
                            >cancel</mat-icon
                          >
                        }
                      </div>
                    }
                  </td>
                  <td class="column-description">
                    @for (f of file.Files; track f) {
                      <div>{{ f?.Description }}</div>
                    }
                  </td>
                  <td class="column-date">
                    @for (f of file.Files; track f) {
                      <div>{{ f?.CreatedOn | date: 'yyyy-MM-dd' }}</div>
                    }
                  </td>
                  <td class="column-isattached">
                    @if (!file.Files) {
                      <span><mat-icon>error</mat-icon></span>
                    }
                    @if (!!file.Files) {
                      <span><mat-icon>check</mat-icon></span>
                    }
                  </td>
                  <td class="column-actions">
                    @for (f of file.Files; track f) {
                      <div>
                        <button
                          id="documents-section-download-employment-document-button"
                          mat-icon-button
                          color="primary"
                          (click)="downloadFile(f.Id, f.Name, file.EmploymentHistoryRecordId)"
                        >
                          <mat-icon>download</mat-icon>
                        </button>
                      </div>
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!-- Documents -->
    <app-worker-documents-list
      *hasPermissionToModule="moduleNames.ApplicationsAndCertificates"
      [workerId]="profile.WorkerId"
      [documentsExpansionHeaderHeight]="documentsExpansionHeaderHeight"
    >
    </app-worker-documents-list>
    <app-additional-documents-section [workerId]="profile.WorkerId"> </app-additional-documents-section>

  </div>
}
